var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M33.5992 14.8925C33.4651 14.8734 33.3309 14.8734 33.1967 14.8925C30.2259 14.7967 27.8684 12.3625 27.8684 9.37254C27.8684 6.32504 30.3409 3.83337 33.4076 3.83337C36.4551 3.83337 38.9467 6.30587 38.9467 9.37254C38.9276 12.3625 36.5701 14.7967 33.5992 14.8925Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M39.8475 28.175C37.7008 29.6125 34.6917 30.1492 31.9125 29.785C32.6408 28.2133 33.0242 26.4692 33.0433 24.6292C33.0433 22.7125 32.6217 20.8917 31.8167 19.3009C34.6533 18.9175 37.6625 19.4542 39.8283 20.8917C42.8567 22.885 42.8567 26.1625 39.8475 28.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M12.3433 14.8925C12.4775 14.8734 12.6117 14.8734 12.7458 14.8925C15.7167 14.7967 18.0742 12.3625 18.0742 9.37254C18.0742 6.32504 15.6017 3.83337 12.535 3.83337C9.48751 3.83337 6.99585 6.30587 6.99585 9.37254C7.01502 12.3625 9.37251 14.7967 12.3433 14.8925Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M12.5541 24.6292C12.5541 26.4884 12.9566 28.2517 13.685 29.8425C10.9825 30.13 8.16498 29.555 6.09498 28.1942C3.06665 26.1817 3.06665 22.9042 6.09498 20.8917C8.14581 19.5117 11.04 18.9559 13.7616 19.2625C12.9758 20.8725 12.5541 22.6934 12.5541 24.6292Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.23 30.4175C23.0766 30.3983 22.9041 30.3983 22.7316 30.4175C19.205 30.3025 16.3875 27.4083 16.3875 23.8433C16.3875 20.2017 19.32 17.25 22.9808 17.25C26.6225 17.25 29.5741 20.2017 29.5741 23.8433C29.5741 27.4083 26.7758 30.3025 23.23 30.4175Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.0009 34.3851C14.1068 36.3209 14.1068 39.5026 17.0009 41.4192C20.2976 43.6234 25.7026 43.6234 28.9993 41.4192C31.8935 39.4834 31.8935 36.3017 28.9993 34.3851C25.7218 32.1809 20.3168 32.1809 17.0009 34.3851Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.e6cf9de370869a5ef680c2f75b9658d4.svg";
export { ForwardRef as ReactComponent };